import { useLang } from '@/hooks/useLang';

const copy = {
  EN: {
    tag: 'About',
    title: 'A new approach to storytelling.',
    sub: 'Powered by artificial intelligence.',
    body: 'KODO is not a production company. It is a content creation system — built to produce films, series, training content, and interactive experiences at a scale and speed that was never possible before.',
    values: [
      { icon: 'ri-brain-line', label: 'AI-First' },
      { icon: 'ri-global-line', label: 'Global Reach' },
      { icon: 'ri-infinity-line', label: 'Limitless Scale' },
      { icon: 'ri-heart-line', label: 'Human Soul' },
    ],
  },
  TR: {
    tag: 'Hakkımızda',
    title: 'Hikaye anlatımına yeni bir yaklaşım.',
    sub: 'Yapay zeka ile güçlendirilmiş.',
    body: 'KODO bir prodüksiyon şirketi değil. Film, dizi, eğitim içeriği ve etkileşimli deneyimler üretmek için inşa edilmiş bir içerik üretim sistemidir — daha önce hiç mümkün olmayan bir ölçek ve hızda.',
    values: [
      { icon: 'ri-brain-line', label: 'Yapay Zeka Öncelikli' },
      { icon: 'ri-global-line', label: 'Küresel Erişim' },
      { icon: 'ri-infinity-line', label: 'Sınırsız Ölçek' },
      { icon: 'ri-heart-line', label: 'İnsan Ruhu' },
    ],
  },
};

export default function VisionSection() {
  const lang = useLang();
  const t = copy[lang];

  return (
    <section id="vision" className="py-32 bg-white overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-8 md:px-16">
        <div className="flex flex-col lg:flex-row gap-20 items-center">
          {/* Left: Uploaded custom visual */}
          <div className="flex-1 w-full">
            <div className="relative w-full aspect-[4/3] rounded-2xl overflow-hidden bg-gray-50 border border-gray-100">
              <img
                src="https://storage.readdy-site.link/project_files/1460d35d-0d85-434d-9ed7-7e4515871db4/dbc31e66-5cff-4add-a7f2-82bfb599c7b5_x2.jpg?v=dd138962514762c60e67fe5aaf960e74"
                alt="KODO Vision"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          {/* Right: Text */}
          <div className="flex-1">
            <span className="text-xs font-semibold text-gray-400 tracking-widest uppercase mb-3 block">
              {t.tag}
            </span>
            <h2
              className="text-4xl md:text-5xl font-black text-gray-900 tracking-tight mb-2"
              style={{ fontFamily: "'Space Grotesk', sans-serif" }}
            >
              {t.title}
            </h2>
            <p className="text-xl text-gray-400 font-light mb-8">{t.sub}</p>
            <p className="text-base text-gray-500 leading-relaxed mb-12 max-w-md">{t.body}</p>

            {/* Values */}
            <div className="grid grid-cols-2 gap-4">
              {t.values.map((v) => (
                <div
                  key={v.label}
                  className="flex items-center gap-3 p-4 bg-gray-50 rounded-xl border border-gray-100"
                >
                  <div className="w-8 h-8 rounded-lg bg-white border border-gray-100 flex items-center justify-center flex-shrink-0">
                    <i
                      className={`${v.icon} text-gray-400 text-sm w-4 h-4 flex items-center justify-center`}
                    ></i>
                  </div>
                  <span className="text-sm font-semibold text-gray-700">{v.label}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
